import React, { useEffect, useState, } from 'react';
import { AccordionArrow, ColorTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
import { TouchableOpacity, View, } from 'react-native';
/**
 * Primary UI component for user interaction
 */
export const AccordionList = ({ id, renderItem, activeIndex = 1, data, rightIcon = AccordionArrow.RIGHT, disableSecond, updateCounter, isDarkMode }) => {
    const [toggle, setToggle] = useState(activeIndex);
    const [dataX, setDataX] = useState(data);
    const [isFirstRender, setFirtRender] = useState(true);
    let handleToggle = (id) => {
        if (isFirstRender) {
            if (disableSecond && id === 2) {
                null;
            }
            else {
                setToggle(id);
            }
        }
        if (toggle === id) {
            setToggle(null);
            return false;
        }
        if (disableSecond && id === 2) {
            null;
        }
        else {
            setToggle(id);
        }
    };
    useEffect(() => {
        setFirtRender(false);
    }, []);
    useEffect(() => {
        setToggle(activeIndex);
    }, [activeIndex, updateCounter]);
    const child = (item) => (React.createElement(React.Fragment, null, [
        item?.children,
        React.createElement(View, null, renderItem &&
            item?.widgetItems?.length > 0 &&
            item?.widgetItems.map(renderItem)),
    ]));
    const childTitle = (item) => (React.createElement(React.Fragment, null, [
        item?.children,
        React.createElement(View, null, renderItem &&
            item?.widgetItems?.length > 0 &&
            item?.widgetItems.map(renderItem)),
    ]));
    return (React.createElement(React.Fragment, null,
        React.createElement(View, null, dataX.map((value) => {
            return (React.createElement(View, { nativeID: id ? id : value.qaId, key: value.id, style: [
                    rightIcon === AccordionArrow.RIGHT
                        ? disableSecond ? {
                            borderColor: '#E7EBFA',
                            borderWidth: 1,
                        } : {
                            borderColor: '#E7EBFA',
                            marginBottom: 16,
                            borderWidth: 1,
                        }
                        : { paddingVertical: 4 },
                    {
                        backgroundColor: isDarkMode ? '#0D141F' : 'white',
                    },
                ] },
                React.createElement(View, { style: {} },
                    React.createElement(TouchableOpacity, { onPress: () => handleToggle(value.id) },
                        React.createElement(View, { style: [
                                rightIcon === AccordionArrow.RIGHT
                                    ? {
                                        borderColor: '#E7EBFA',
                                        paddingHorizontal: 16,
                                    }
                                    : { borderColor: '#F1F3F5' },
                                {
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    backgroundColor: isDarkMode ? '#0D141F' : 'white',
                                    paddingVertical: 4,
                                    height: 56,
                                },
                            ] },
                            rightIcon === AccordionArrow.RIGHT
                                ? childTitle(value.header)
                                : null,
                            React.createElement(View, { style: [
                                    rightIcon === AccordionArrow.RIGHT
                                        ? {
                                            flex: 1,
                                            alignItems: 'flex-end',
                                            justifyContent: 'flex-end',
                                        }
                                        : { marginRight: 12 },
                                    {},
                                ] }, value.id === toggle ? (React.createElement(Icon, { name: IconTokens.UpsideArrow, size: IconSizeTokens.XXS, color: ColorTokens.Grey_Charcoal })) : (React.createElement(Icon, { name: IconTokens.DownArrow, size: IconSizeTokens.XXS, color: ColorTokens.Grey_Charcoal }))),
                            rightIcon === AccordionArrow.LEFT
                                ? childTitle(value.header)
                                : null))),
                value.id === toggle ? (React.createElement(View, { style: [
                        rightIcon === AccordionArrow.RIGHT
                            ? {
                                paddingBottom: 10,
                                paddingHorizontal: 10,
                                marginBottom: 15,
                            }
                            : {
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 10,
                            },
                        {
                            backgroundColor: isDarkMode ? '#0D141F' : 'white',
                        },
                    ] }, child(value.body))) : ('')));
        }))));
};
